/**
 * Debug flags for console logging control.
 * - DEBUG_LOGS: Full verbose debug (session, feature-specific logs)
 * - DEBUG_CONNECTIVITY: Essential connectivity only (health state, WebSocket connected/disconnected)
 * - DEBUG_VERBOSE_API: Request/response/headers logging (very noisy, opt-in)
 */
export const DEBUG_LOGS = process.env.REACT_APP_ENABLE_DEBUG_LOGS === 'true';
export const DEBUG_CONNECTIVITY =
  process.env.REACT_APP_DEBUG_CONNECTIVITY === 'true' || DEBUG_LOGS;
export const DEBUG_VERBOSE_API =
  process.env.REACT_APP_DEBUG_VERBOSE_API === 'true';
